import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import Main from './main.vue';

const PromtConstructor = Vue.extend(Main);

function Promt(opts = {}) {
  const instance = new PromtConstructor({
    data: opts,
    store,
    router,
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.show(opts);
  return instance;
}

export default Promt;
